import React from "react";
import { Tabs, Tab } from "@mui/material";
import { FONT_INTER } from "../../../styles/fonts";

const ACCENT_COLOR = "#185CFB";

// Controlled horizontal tab navigation for Globo Marca routes
const NavigationTabs = ({ tabs, value, onChange, sx }) => (
  <Tabs
    value={value}
    onChange={(_event, newValue) => onChange(newValue)}
    sx={{
      minHeight: 40,
      borderBottom: "1px solid #E2E2E3",
      "& .MuiTabs-indicator": {
        backgroundColor: ACCENT_COLOR,
      },
      ...sx,
    }}
  >
    {tabs.map(({ value: tabValue, label }) => (
      <Tab
        key={tabValue}
        value={tabValue}
        label={label}
        sx={{
          minHeight: 40,
          textTransform: "none",
          fontFamily: FONT_INTER,
          fontWeight: 500,
          "&.Mui-selected": {
            color: ACCENT_COLOR,
          },
        }}
      />
    ))}
  </Tabs>
);

export default NavigationTabs;
